/*
 *
 * MeasurementDetails constants
 *
 */

export const GET_DIMENSIONS_WATCHER =
  "app/MeasurementDetails/GET_DIMENSIONS_WATCHER"
export const GET_DIMENSIONS_SUCCESS =
  "app/MeasurementDetails/GET_DIMENSIONS_SUCCESS"
export const GET_DIMENSIONS_FAILED =
  "app/MeasurementDetails/GET_DIMENSIONS_FAILED"

export const DELETE_CD_WATCHER = "app/MeasurementDetails/DELETE_CD_WATCHER"
export const DELETE_CD_SUCCESS = "app/MeasurementDetails/DELETE_CD_SUCCESS"
export const DELETE_CD_FAILED = "app/MeasurementDetails/DELETE_CD_FAILED"

export const RESEND_CD_WATCHER = "app/MeasurementDetails/RESEND_CD_WATCHER"
export const RESEND_CD_SUCCESS = "app/MeasurementDetails/RESEND_CD_SUCCESS"
export const RESEND_CD_FAILED = "app/MeasurementDetails/RESEND_CD_FAILED"

export const GET_STATUS_WATCHER = "app/MeasurementDetails/GET_STATUS_WATCHER"
export const GET_STATUS_SUCCESS = "app/MeasurementDetails/GET_STATUS_SUCCESS"
export const GET_STATUS_FAILED = "app/MeasurementDetails/GET_STATUS_FAILED"

export const GET_DIVISIONS_MEASURE_WATCHER =
  "app/MeasurementDetails/GET_DIVISIONS_MEASURE_WATCHER"
export const GET_DIVISIONS_MEASURE_SUCCESS =
  "app/MeasurementDetails/GET_DIVISIONS_MEASURE_SUCCESS"
export const GET_DIVISIONS_MEASURE_FAILED =
  "app/MeasurementDetails/GET_DIVISIONS_MEASURE_FAILED"

export const GET_QUALITATIVE_QUES_WATCHER =
  "app/MeasurementDetails/GET_QUALITATIVE_QUES_WATCHER"
export const GET_QUALITATIVE_QUES_SUCCESS =
  "app/MeasurementDetails/GET_QUALITATIVE_QUES_SUCCESS"
export const GET_QUALITATIVE_QUES_FAILED =
  "app/MeasurementDetails/GET_QUALITATIVE_QUES_FAILED"

export const GET_DATE_PROG_WATCHER =
  "app/MeasurementDetails/GET_DATE_PROG_WATCHER"
export const GET_DATE_PROG_SUCCESS =
  "app/MeasurementDetails/GET_DATE_PROG_SUCCESS"
export const GET_DATE_PROG_FAILED =
  "app/MeasurementDetails/GET_DATE_PROG_FAILED"

export const EDIT_MEASUREMENT_NAME_WATCHER =
  "app/MeasurementCreate/EDIT_MEASUREMENT_NAME_WATCHER"
export const EDIT_MEASUREMENT_NAME_SUCCESS =
  "app/MeasurementCreate/EDIT_MEASUREMENT_NAME_SUCCESS"
export const EDIT_MEASUREMENT_NAME_FAILED =
  "app/MeasurementCreate/EDIT_MEASUREMENT_NAME_FAILED"

export const DELETE_MEASURE_WATCHER =
  "app/MeasurementCreate/DELETE_MEASURE_WATCHER"
export const DELETE_MEASURE_SUCCESS =
  "app/MeasurementCreate/DELETE_MEASURE_SUCCESS"
export const DELETE_MEASURE_FAILED =
  "app/MeasurementCreate/DELETE_MEASURE_FAILED"

export const RESEND_SURVEY_WATCHER =
  "app/MeasurementCreate/RESEND_SURVEY_WATCHER"
export const RESEND_SURVEY_SUCCESS =
  "app/MeasurementCreate/RESEND_SURVEY_SUCCESS"
export const RESEND_SURVEY_FAILED = "app/MeasurementCreate/RESEND_SURVEY_FAILED"

export const GET_RECIPIENTS_WATCHER =
  "app/MeasurementCreate/GET_RECIPIENTS_WATCHER"
export const GET_RECIPIENTS_SUCCESS =
  "app/MeasurementCreate/GET_RECIPIENTS_SUCCESS"
export const GET_RECIPIENTS_FAILED =
  "app/MeasurementCreate/GET_RECIPIENTS_FAILED"

export const GET_RECIPIENTS_SEGMENTS_WATCHER =
  "app/MeasurementDetails/GET_RECIPIENTS_SEGMENTS_WATCHER"
export const GET_RECIPIENTS_SEGMENTS_SUCCESS =
  "app/MeasurementDetails/GET_RECIPIENTS_SEGMENTS_SUCCESS"
export const GET_RECIPIENTS_SEGMENTS_FAILED =
  "app/MeasurementDetails/GET_RECIPIENTS_SEGMENTS_FAILED"

export const GET_LEADERS_SEGMENTS_WATCHER =
  "app/MeasurementDetails/GET_LEADERS_SEGMENTS_WATCHER"
export const GET_LEADERS_SEGMENTS_SUCCESS =
  "app/MeasurementDetails/GET_LEADERS_SEGMENTS_SUCCESS"
export const GET_LEADERS_SEGMENTS_FAILED =
  "app/MeasurementDetails/GET_LEADERS_SEGMENTS_FAILED"

export const POST_RECIPIENTS_WATCHER =
  "app/MeasurementCreate/POST_RECIPIENTS_WATCHER"
export const POST_RECIPIENTS_SUCCESS =
  "app/MeasurementCreate/POST_RECIPIENTS_SUCCESS"
export const POST_RECIPIENTS_FAILED =
  "app/MeasurementCreate/POST_RECIPIENTS_FAILED"

export const GET_DATES_WATCHER = "app/MeasurementCreate/GET_DATES_WATCHER"
export const GET_DATES_SUCCESS = "app/MeasurementCreate/GET_DATES_SUCCESS"
export const GET_DATES_FAILED = "app/MeasurementCreate/GET_DATES_FAILED"

export const EDIT_DATES_WATCHER = "app/MeasurementCreate/EDIT_DATES_WATCHER"
export const EDIT_DATES_SUCCESS = "app/MeasurementCreate/EDIT_DATES_SUCCESS"
export const EDIT_DATES_FAILED = "app/MeasurementCreate/EDIT_DATES_FAILED"

export const GET_DIMENSIONS_RANK_WATCHER =
  "app/MeasurementCreate/GET_DIMENSIONS_RANK_WATCHER"
export const GET_DIMENSIONS_RANK_SUCCESS =
  "app/MeasurementCreate/GET_DIMENSIONS_RANK_SUCCESS"
export const GET_DIMENSIONS_RANK_FAILED =
  "app/MeasurementCreate/GET_DIMENSIONS_RANK_FAILED"

export const COUNT_COLLABORATORS_SUCCESS =
  "app/MeasurementCreate/COUNT_COLLABORATORS_SUCCESS"

export const DOWNLOAD_RECIPIENTS_WATCHER =
  "app/MeasurementDetails/DOWNLOAD_RECIPIENTS_WATCHER"
export const DOWNLOAD_RECIPIENTS_SUCCESS =
  "app/MeasurementDetails/DOWNLOAD_RECIPIENTS_SUCCESS"
export const DOWNLOAD_RECIPIENTS_FAILED =
  "app/MeasurementDetails/DOWNLOAD_RECIPIENTS_FAILED"

export const GET_SURVEYS_TYPE_WATCHER =
  "app/MeasurementDetails/GET_SURVEYS_TYPE_WATCHER"
export const GET_SURVEYS_TYPE_SUCCESS =
  "app/MeasurementDetails/GET_SURVEYS_TYPE_SUCCESS"
export const GET_SURVEYS_TYPE_FAILED =
  "app/MeasurementDetails/GET_SURVEYS_TYPE_FAILED"

export const GET_LEADERS_DETAILS_WATCHER =
  "app/MeasurementDetails/GET_LEADERS_DETAILS_WATCHER"
export const GET_LEADERS_DETAILS_SUCCESS =
  "app/MeasurementDetails/GET_LEADERS_DETAILS_SUCCESS"
export const GET_LEADERS_DETAILS_FAILED =
  "app/MeasurementDetails/GET_LEADERS_DETAILS_FAILED"

export const SEND_TEST_MEASURE_WATCHER =
  "app/MeasurementDetails/SEND_TEST_MEASURE_WATCHER"
export const SEND_TEST_MEASURE_SUCCESS =
  "app/MeasurementDetails/SEND_TEST_MEASURE_SUCCESS"
export const SEND_TEST_MEASURE_FAILED =
  "app/MeasurementDetails/SEND_TEST_MEASURE_FAILED"

export const POST_EXPORT_REPORT_WATCHER =
  "app/MeasurementDetails/POST_EXPORT_REPORT_WATCHER"
export const POST_EXPORT_REPORT_SUCCESS =
  "app/MeasurementDetails/POST_EXPORT_REPORT_SUCCESS"
export const POST_EXPORT_REPORT_FAILED =
  "app/MeasurementDetails/POST_EXPORT_REPORT_FAILED"

export const GET_DIVISIONS_TREE_MEASURE_WATCHER =
  "app/MeasurementDetails/GET_DIVISIONS_TREE_MEASURE_WATCHER"
export const GET_DIVISIONS_TREE_MEASURE_SUCCESS =
  "app/MeasurementDetails/GET_DIVISIONS_TREE_MEASURE_SUCCESS"
export const GET_DIVISIONS_TREE_MEASURE_FAILED =
  "app/MeasurementDetails/GET_DIVISIONS_TREE_MEASURE_FAILED"

export const SET_INCLUDE_SUBDIVISION_WATCHER =
  "app/MeasurementCreate/SET_INCLUDE_SUBDIVISION_WATCHER"

export const GET_MEASURE_COLOR_RANGE_WATCHER =
  "app/MeasurementCreate/GET_MEASURE_COLOR_RANGE_WATCHER"
export const GET_MEASURE_COLOR_RANGE_SUCCESS =
  "app/MeasurementCreate/GET_MEASURE_COLOR_RANGE_SUCCESS"

export const GET_POSSIBLE_RECIPIENTS_WATCHER =
  "app/MeasurementDetails/GET_POSSIBLE_RECIPIENTS_WATCHER"
export const GET_POSSIBLE_RECIPIENTS_SUCCESS =
  "app/MeasurementDetails/GET_POSSIBLE_RECIPIENTS_SUCCESS"
export const GET_POSSIBLE_RECIPIENTS_FAILED =
  "app/MeasurementDetails/GET_POSSIBLE_RECIPIENTS_FAILED"

export const ADD_COLLABORATORS_WATCHER =
  "app/MeasurementDetails/ADD_COLLABORATORS_WATCHER"
export const ADD_COLLABORATORS_SUCCESS =
  "app/MeasurementDetails/ADD_COLLABORATORS_SUCCESS"
export const ADD_COLLABORATORS_FAILED =
  "app/MeasurementDetails/ADD_COLLABORATORS_FAILED"

export const GET_MEASURE_ENGAGEMENT_WATCHER =
  "app/MeasurementDetails/GET_MEASURE_ENGAGEMENT_WATCHER"
export const GET_MEASURE_ENGAGEMENT_SUCCESS =
  "app/MeasurementDetails/GET_MEASURE_ENGAGEMENT_SUCCESS"
export const GET_MEASURE_ENGAGEMENT_FAILED =
  "app/MeasurementDetails/GET_MEASURE_ENGAGEMENT_FAILED"

export const GET_MEASURE_GENERAL_WATCHER =
  "app/MeasurementDetails/GET_MEASURE_GENERAL_WATCHER"
export const GET_MEASURE_GENERAL_SUCCESS =
  "app/MeasurementDetails/GET_MEASURE_GENERAL_SUCCESS"
export const GET_MEASURE_GENERAL_FAILED =
  "app/MeasurementDetails/GET_MEASURE_GENERAL_FAILED"

export const GET_MEASURE_TOTAL_WATCHER =
  "app/MeasurementDetails/GET_MEASURE_TOTAL_WATCHER"
export const GET_MEASURE_TOTAL_SUCCESS =
  "app/MeasurementDetails/GET_MEASURE_TOTAL_SUCCESS"
export const GET_MEASURE_TOTAL_FAILED =
  "app/MeasurementDetails/GET_MEASURE_TOTAL_FAILED"

export const GET_MEASURE_INFO_WATCHER =
  "app/MeasurementDetails/GET_MEASURE_INFO_WATCHER"
export const GET_MEASURE_INFO_SUCCESS =
  "app/MeasurementDetails/GET_MEASURE_INFO_SUCCESS"
export const GET_MEASURE_INFO_FAILED =
  "app/MeasurementDetails/GET_MEASURE_INFO_FAILED"


export const GET_DETAIL_COUNTS_WATCHER =
  "app/MeasurementDetails/GET_DETAIL_COUNTS_WATCHER"

export const GET_DETAIL_COUNTS_SUCCESS =
  "app/MeasurementDetails/GET_DETAIL_COUNTS_SUCCESS"

export const GET_DETAIL_COUNTS_FAILED =
  "app/MeasurementDetails/GET_DETAIL_COUNTS_FAILED"


export const GET_MEASURE_RATE_WATCHER  =
  "app/MeasurementDetails/GET_MEASURE_RATE_WATCHER"

export const GET_MEASURE_RATE_SUCCESS =
  "app/MeasurementDetails/GET_MEASURE_RATE_SUCCESS"

export const GET_MEASURE_RATE_FAILED =
  "app/MeasurementDetails/GET_MEASURE_RATE_FAILED"
